<select class="form-control" [(ngModel)]="selected">
  @for (option of options; track option) {
    <option [value]="option.value"
      [disabled]="option.disabled">
      {{option.label}}
    </option>
  }
</select>
